import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'utentik_cookie_consent';

export const getCookieConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (e) {
    console.debug('Cookie consent read error:', e.message);
    return null;
  }
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getCookieConsent();
    if (!consent) {
      // Show after a short delay for better UX
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
    // Disable Amplitude tracking
    try {
      const amplitude = require('@amplitude/unified');
      amplitude.setOptOut(true);
    } catch (e) {
      console.debug('Amplitude opt-out:', e.message);
    }
  };

  const handleDismiss = () => {
    // Just hide for this session — no consent stored, banner returns next visit
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-20 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-[55] animate-fade-in"
      data-testid="cookie-banner"
    >
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-4">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
            <Cookie className="w-4 h-4 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-gray-600 leading-relaxed mb-3">
              Usamos cookies y herramientas de análisis para mejorar tu experiencia.{' '}
              <Link to="/legal" className="text-primary hover:underline">
                Más información
              </Link>
            </p>
            <div className="flex items-center gap-2">
              <button
                onClick={handleAccept}
                className="flex-1 px-4 py-2 bg-gray-900 text-white text-xs font-medium rounded-lg hover:bg-gray-800 transition-colors"
                data-testid="cookie-accept"
              >
                Aceptar
              </button>
              <button
                onClick={handleDecline}
                className="flex-1 px-4 py-2 bg-gray-100 text-gray-600 text-xs font-medium rounded-lg hover:bg-gray-200 transition-colors"
                data-testid="cookie-decline"
              >
                Rechazar
              </button>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="p-1 rounded-full hover:bg-gray-100 flex-shrink-0"
            data-testid="cookie-close"
          >
            <X className="w-3.5 h-3.5 text-gray-400" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
